import React from 'react';
import { Box, SxProps } from '@mui/system';

interface Props {
  isOpen: boolean;
  className?: string;
  style?: any;
}
const chevron = (isOpen: boolean) =>
  ({
    height: 18,
    width: 18,
    marginLeft: '4px',
    '&:after': {
      content: '""',
      display: 'inline-block',
      position: 'relative',
      top: isOpen ? '3px' : '-3px',
      left: '50%',
      height: 8,
      width: 8,
      borderRight: '1.5px solid',
      borderBottom: '1.5px solid',
      borderColor: 'inherit',
      transform: isOpen
        ? 'rotate(-135deg) translate(50%, -50%)'
        : 'rotate(45deg) translate(-50%, 50%)',
    },
  } as SxProps);

const KeyboardArrowIcon: React.FC<Props> = ({
  isOpen,
  className = '',
  style = {},
}: Props) => {
  return <Box className={className} style={style} sx={chevron(isOpen)} />;
};

export default KeyboardArrowIcon;
